import { scaleLinear } from 'd3-scale';
import { transparentize } from 'polished';
export var generateSeriesBlockHeight = function (minimum, maximum, yScale, minKeyNameValue, maxKeyNameValue, isNegativeSeries) {
    var isMinNegative = Math.sign(minKeyNameValue) === -1;
    var height = isMinNegative
        ? yScale(minKeyNameValue)
        : yScale(minimum > 0 ? minimum : 0);
    var negativeMaxPos = maximum > 0 && maxKeyNameValue < 0 ? 0 : maxKeyNameValue;
    return {
        y: isNegativeSeries ? yScale(maximum) : yScale(negativeMaxPos),
        height: height - (isNegativeSeries ? yScale(maximum) : yScale(negativeMaxPos)),
    };
};
export var generateAreaGradient = function (minKeyNameValue, maxKeyNameValue, color, gradientMin, gradientMax) {
    var isMaxNegative = Math.sign(maxKeyNameValue) === -1;
    var isMinNegative = Math.sign(minKeyNameValue) === -1;
    var positiveMax = isMaxNegative ? 0 : Math.abs(maxKeyNameValue);
    var positiveMin = isMinNegative ? Math.abs(minKeyNameValue) : 0;
    var maxValue = positiveMax > positiveMin ? positiveMax : positiveMin;
    var minAndMaxValueAreZero = positiveMax === 0 && positiveMin === 0;
    var colorScale = scaleLinear()
        .domain([0, maxValue])
        .range([
        transparentize(1 - gradientMin, color),
        transparentize(1 - gradientMax, color),
    ]);
    return {
        positiveColor: colorScale(positiveMax),
        zeroPointColor: colorScale(0),
        negativeColor: colorScale(positiveMin),
        gradientZeroPercent: minAndMaxValueAreZero
            ? 0
            : (positiveMax / (positiveMax + positiveMin)) * 100,
    };
};
